import { useTranslation } from "react-i18next";

// Utility function to handle required messages with translation support
export const requiredMessage = (t, name) => {
  return t("validation.requiredMessage", { name });
};

export const requiredSelect = (t, name) => {
  return t("validation.requiredSelect", { name });
};

export const requiredDate = (t, name) => {
  return t("validation.requiredDate", { name });
};

// Example of using these functions in a component
export const useValidationMessages = () => {
  const { t } = useTranslation();

  return {
    requiredMessage: (name) => requiredMessage(t, name),
    requiredSelect: (name) => requiredSelect(t, name),
    requiredDate: (name) => requiredDate(t, name),
  };
};
